function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ServiceDetails as ServiceDetailsComponent } from '../components/serviceDetails';
import { ensureServiceDetailsData } from '@shared/actions/thunkActions';
import { extractCountryCodeFromQueryParam } from '@shared/utils/consultingServicesUtils';
import { connect } from 'react-redux';
import { withRouter } from '@shared/routerHistory';
import { Constants } from '@shared/utils/constants';
import { isProfessionalService, getTelemetryDetailContentCurrentView } from '@shared/utils/appUtils';
import { withHydration } from '@shared/hooks/useHydration';
export const mapStateToProps = (state, ownProps)=>{
    const services = state.services.dataList;
    const hashMap = state.services.idMap;
    const query = ownProps.location ? ownProps.location.query : null;
    const serviceIndex = hashMap[ownProps.routeParams.entityId.toString().toLowerCase()];
    let targetService = null;
    if (serviceIndex >= 0) {
        targetService = services[`${serviceIndex}`];
    }
    const breadcrumbUrl = state.config.breadcrumbUrl ? state.config.breadcrumbUrl : '/' + state.config.locale + '/marketplace/consulting-services';
    const defaultTab = query && query.tab ? query.tab : null;
    // If the query has the country code that wins, else select first available country from the service.
    let countryCode = extractCountryCodeFromQueryParam(query);
    if (!countryCode && targetService && targetService.countryRegion && targetService.countryRegion[0]) {
        countryCode = targetService.countryRegion[0];
    }
    const offerIsProfessionalService = (targetService === null || targetService === void 0 ? void 0 : targetService.entityType) === Constants.EntityType.Service && isProfessionalService({
        service: targetService
    });
    return _object_spread_props(_object_spread({}, ownProps), {
        isLoadingUserData: state.users.loading,
        service: targetService,
        serviceId: ownProps.routeParams.entityId.toString().toLowerCase(),
        breadcrumbUrl,
        defaultTab,
        selectedLocale: state.config.locale,
        isNationalCloud: !!state.config.nationalCloud,
        currentView: getTelemetryDetailContentCurrentView(state.config.currentView, state.config.currentGalleryViewIsCurated),
        countryCode,
        query: query,
        isAppSource: state.config.isAppSource,
        suggestedItems: state.services.relatedAppsItems.items.suggestedItems || [],
        isProfessionalService: offerIsProfessionalService,
        isConverged: state.config.isConverged
    });
};
function ensureAsyncData(dispatch, entityId) {
    return dispatch(ensureServiceDetailsData(entityId));
}
export const mapDispatchToProps = (dispatch)=>{
    return {
        ensureAsyncData: (entityId)=>ensureAsyncData(dispatch, entityId)
    };
};
const ServiceDetails = withRouter(connect(mapStateToProps, mapDispatchToProps)(withHydration(ServiceDetailsComponent)));
export const ensureAsyncDataSSR = (dispatch, getState, params)=>_async_to_generator(function*() {
        yield ensureAsyncData(dispatch, params.entityId);
    })();
export default ServiceDetails;
